module.exports = __webpack_public_path__ + "img/services.814ecd50.svg";